import { render, staticRenderFns } from "./ProductsDataDeviceV3.vue?vue&type=template&id=d59056f2&"
import script from "./ProductsDataDeviceV3.vue?vue&type=script&lang=js&"
export * from "./ProductsDataDeviceV3.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDataDeviceV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports